import RosterIdentityQrCodeDownload from './RosterIdentityQrCodeDownload';

export default RosterIdentityQrCodeDownload;
